/** PuraDorse — custom cart + AMOSE product bridge. */
(function () {
  if (window.pdCart) return;

  var DRAWER = '#cart-drawer';
  var INNER = '.cart-drawer__inner';

  function refreshDrawer() {
    return fetch(window.location.pathname + '?section_id=cart-drawer-section', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (r) {
        if (!r.ok) throw new Error('section');
        return r.text();
      })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(INNER);
        var current = document.querySelector(DRAWER + ' ' + INNER);
        if (fresh && current) current.replaceWith(fresh);
      })
      .catch(function () {});
  }

  function notifyTheme() {
    try {
      var ev = new Event('shopify:cart:lines-update', { bubbles: true });
      ev.action = 'add';
      document.dispatchEvent(ev);
    } catch (e) {}
  }

  function openDrawer() {
    var host = document.querySelector(DRAWER);
    if (!host) return;
    var dialog = host.querySelector('dialog');
    if (dialog && dialog.open) return;
    try {
      if (typeof host.open === 'function') {
        host.open();
        return;
      }
    } catch (e) {}
    if (dialog) {
      try {
        dialog.showModal();
      } catch (e) {
        window.location.href = '/cart';
      }
    }
  }

  function add(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add');
        return r.json();
      })
      .then(function (data) {
        return refreshDrawer().then(function () {
          notifyTheme();
          setTimeout(openDrawer, 60);
          return data;
        });
      });
  }

  window.pdCart = { add: add, refreshDrawer: refreshDrawer, openDrawer: openDrawer };

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-pd-add]') : null;
    if (!button) return;
    event.preventDefault();

    var row = button.closest('[data-pd-row]');
    var select = row ? row.querySelector('[data-pd-variant]') : null;
    var id = parseInt((select && select.value) || button.getAttribute('data-pd-add'), 10);
    if (!id) return;

    var label = button.textContent;
    button.disabled = true;
    button.textContent = 'Ajout…';

    add([{ id: id, quantity: 1 }]).catch(function () {
      button.disabled = false;
      button.textContent = label;
      window.alert("L'ajout au panier a échoué. Merci de réessayer.");
    });
  });

  function initAmoseProductBridge() {
    if (window.location.pathname.indexOf('/products/') !== 0) return;

    var attempts = 0;
    var maxAttempts = 40;

    function mount() {
      attempts += 1;

      var root = document.querySelector('.amose-product-info-2-root');
      var upperForm = root && root.querySelector('form[action*="/cart/add"]');
      var upperRow = root && root.querySelector('[data-amose-pi2-atc-wrap]');
      var atc = root && root.querySelector('[data-amose-pi2-atc]');
      var legacyBuyNow = root && root.querySelector('[data-amose-pi2-buy-now]');
      var lower = document.getElementById('shopify-section-main');
      var shopPay = lower && lower.querySelector('.shopify-payment-button');

      if (!root || !upperForm || !upperRow || !atc || !lower) {
        if (attempts < maxAttempts) setTimeout(mount, 150);
        return;
      }

      if (legacyBuyNow) {
        legacyBuyNow.hidden = true;
        legacyBuyNow.style.display = 'none';
      }

      if (!atc.dataset.pdCartBound) {
        atc.dataset.pdCartBound = 'true';

        function handleAtc(event) {
          if (event) event.preventDefault();
          if (atc.dataset.pdBusy === 'true') return;

          var formData = new FormData(upperForm);
          var id = parseInt(formData.get('id'), 10);
          var quantity = parseInt(formData.get('quantity'), 10) || 1;

          if (!id) {
            window.alert("Impossible de déterminer la variante sélectionnée.");
            return;
          }

          atc.dataset.pdBusy = 'true';
          atc.disabled = true;
          atc.setAttribute('aria-busy', 'true');

          add([{ id: id, quantity: quantity }])
            .catch(function (err) {
              window.alert(
                err && err.message
                  ? err.message
                  : "L'ajout au panier a échoué. Merci de réessayer."
              );
            })
            .finally(function () {
              atc.disabled = false;
              atc.removeAttribute('aria-busy');
              atc.dataset.pdBusy = 'false';
            });
        }

        atc.addEventListener('click', handleAtc, true);
        upperForm.addEventListener('submit', function (event) {
          if (event.submitter === atc) handleAtc(event);
        }, true);
      }

      if (shopPay && shopPay.parentNode !== upperRow) {
        shopPay.classList.add('amose-pi2__moved-shopify-payment-button');
        shopPay.dataset.pdMovedToAmose = 'true';
        upperRow.appendChild(shopPay);
      }

      lower.style.display = 'none';

      if (!shopPay && attempts < maxAttempts) setTimeout(mount, 150);
    }

    mount();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mount, { once: true });
    }

    var observer = new MutationObserver(function () {
      if (attempts < maxAttempts) mount();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 7000);
  }

  initAmoseProductBridge();
})();
